import React from 'react';
import {
  Row, Col, Badge, Button,
} from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
// import DeleteIcon from 'mdi-react/DeleteIcon';
import AssetModalLeft from './AssetModalLeft';
import AssetModalHeader from './AssetModalHeader';
import { getNaturePartByValue, getContractTypeByValue } from '../../../utils/functions';
import AssetModalContacts from './AssetModalContacts';
// import AssetModalDecisions from './AssetModalDecisions';

const idLocale = require('moment/locale/fr');

moment.locale('fr', idLocale);

const renderUsername = (data, contacts, accesses) => {
  const { subcategory, cloud_choice, category } = data;
  if (
    subcategory === 'account_personal'
    || subcategory === 'social_network'
    || subcategory === 'email'
    || (category === 'numeric' && subcategory !== 'crypto_wallet')
    ) {
    return (
      <div className="mt-20">
        <div className="leftInfo">
          <h5 className="bold-text">Identifiant de connexion</h5>
        </div>
        <div className="rightInfo">
          {
            data.login_email ? (
              <Badge color="success">{data.login_email}</Badge>
            ) : (
              <Badge color="warning">Non renseigné</Badge>
            )
          }
        </div>
        {
          data.login_other && (
            <div className="mt-20">
              <div className="leftInfo">
                <h5 className="bold-text">Autre identifiant</h5>
              </div>
              <div className="rightInfo">
                <Badge color="success">{data.login_other}</Badge>
              </div>
            </div>
          )
        }
        {
          data.url && (
            <div className="mt-20">
              <div className="leftInfo">
                <h5 className="bold-text">Lien du profil</h5>
              </div>
              <div className="rightInfo">
                <Badge color="success">
                  <a href={data.url} rel="noopener noreferrer" target="_blank">{data.url}</a>
                </Badge>
              </div>
            </div>
          )
        }
      </div>
    );
  }
  if (subcategory === 'cloud_storage' || subcategory === 'cloud_photo') {
    if (cloud_choice === 'delete') {
      return (
        <div className="mt-20">
          <div className="leftInfo">
            <h5 className="bold-text">Identifiant</h5>
          </div>
          <div className="rightInfo">
            {
              data.login_email ? (
                <Badge color="success">{data.login_email}</Badge>
              ) : (
                <Badge color="warning">Non renseigné</Badge>
              )
            }
          </div>
          <div className="mt-20">
            <div className="leftInfo">
              <h5 className="bold-text">Vos choix en cas de décès</h5>
            </div>
            <div className="rightInfo">
              <Badge color="success">Suppression intégrale</Badge>
            </div>
          </div>
        </div>
      );
    }
    const { permalinks } = data;
    return (
      <div style={{ marginTop: 20 }}>
        <div className="mt-20">
          <div className="leftInfo">
            <h5 className="bold-text">Vos choix en cas de décès</h5>
          </div>
          <div className="rightInfo">
            <Badge color="success">
              {
                cloud_choice === 'transmit_part' ? 'Transmission d\'une partie' : 'Transmission en totalité'
              }
            </Badge>
          </div>
        </div>
        <h5 className="bold-text mb-10 mt-20">Permalink{permalinks && permalinks.length !== 1 && 's'} :</h5>
        {
          permalinks && permalinks.length > 0 ? (
            permalinks.map((item, index) => (
              <div key={item.url} className="permaGroup mt-30">
                <div className="leftInfo">
                  <h5 className="bold-text">Lien</h5>
                </div>
                <div className="rightInfo">
                  <a href={item.url} rel="noopener noreferrer" target="_blank">{item.url}</a>
                </div>
                {
                  <div className="mt-20">
                    <div className="leftInfo">
                      <h5 className="bold-text">Bénéficiaires</h5>
                    </div>
                    <div className="rightInfo listContacts">
                      <AssetModalContacts accesses={accesses} isPermalink data={item} contacts={contacts} />
                    </div>
                  </div>
                }
                <span className="permaTitle text-gold">{item.name || `Lien ${index + 1}`}</span>
              </div>
            ))
          ) : (
            <p>
              Non renseigné
            </p>
          )
        }
      </div>
    );
  }
  if (subcategory === 'insurance'
  || subcategory === 'life_insurance'
  || subcategory === 'provident_insurance'
  || subcategory === 'funeral_insurance'
  ) {
    return (
      <div className="mt-20">
        {subcategory !== 'funeral_insurance' && <AssetModalContacts isViewOnly isBeneficiary accesses={accesses} data={data} contacts={contacts} />}
      </div>
    );
  }
  return null;
};

const renderCryptoArea = (data, contacts, accesses) => (
  <div className="mt-20">
    <div className="leftInfo">
      <h5 className="bold-text">Clé publique</h5>
    </div>
    <div className="rightInfo">
      <Badge color="success">{data.public_key}</Badge>
    </div>
    <div className="mt-20">
      <div className="leftInfo">
        <h5 className="bold-text">Répartition de la graine</h5>
      </div>
      <div className="rightInfo">
        {
          (data.secureKeyChoice === 'legitbee' || data.secureKeyChoice === 'legitbee_other') && (
            <img style={{ width: 30, height: 30 }} src={`${process.env.PUBLIC_URL}/img/logo/legitbee.png`} alt="legitbee_img" />
          )
        }
        { data.secureKeyChoice === 'legitbee_other' && <b className="mr-10 ml-10"> + </b>}
        <AssetModalContacts accesses={accesses} isCrypto contacts={contacts} data={data} />
        {/* <Badge color="success">{getSecureKeyNameByValue(data.secureKeyChoice)}</Badge> */}
      </div>
    </div>
  </div>
);

// adresse d'un bien immobilier par exemple
const renderAddress = data => (
  <div className="mt-20">
    <div className="leftInfo">
      <h5 className="bold-text">{['art', 'item'].includes(data.category) ? 'Lieu de conservation' : 'Adresse'}</h5>
    </div>
    <div className="rightInfo">
      <Badge color="success">{data.address}</Badge>
    </div>
  </div>
);

const renderContractType = contract_type => (
  <div className="mt-20">
    <div className="leftInfo">
      <h5 className="bold-text">Nature du Plan</h5>
    </div>
    <div className="rightInfo">
      <Badge color="success">{getContractTypeByValue(contract_type)}</Badge>
    </div>
  </div>
);

const renderMemorial = (data, contacts) => (
  <div className="mt-20">
    <div className="leftInfo">
      <h5 className="bold-text">Que deviendra le compte</h5>
    </div>
    <div className="rightInfo">
      <Badge color="success">Compte commémoratif</Badge>
    </div>
    {
      data.contacts && data.contacts.length > 0 && (
      <div className="mt-20">
        <div className="leftInfo">
          <h5 className="bold-text">Contact légataire</h5>
        </div>
        <div className="rightInfo">
          <AssetModalContacts isViewOnly isMemorial contacts={contacts} data={data} />
        </div>
      </div>
      )
    }
  </div>
);

const renderDocuments = (documents, setDocument) => (
  <div className="mt-20">
    <h5 className="bold-text mb-10">Documents:</h5>
    {documents.map(doc => (
      <div key={doc.fullPath} className="ellipsis">
        <Button className="blueish" color="link" onClick={() => setDocument(doc)}>{doc.name}</Button>
      </div>
    ))}
  </div>
);

const renderImages = (images, setDocument) => (
  <div className="mt-20">
    <h5 className="bold-text mb-10">Photos:</h5>
    {images.map(doc => (
      <div key={doc.fullPath}>
        <Button className="blueish" color="link" onClick={() => setDocument(doc)}>{doc.name}</Button>
      </div>
    ))}
  </div>
);


const renderNotes = notes => (
  <div className="mt-20">
    <h5 className="bold-text mb-10">Informations complémentaires :</h5>
    <blockquote>
      <p className="pre-line">{notes}</p>
    </blockquote>
  </div>
);

const renderBic = bic => (
  <div className="mt-20">
    <div className="leftInfo">
      <h5 className="bold-text">Code BIC / SWIFT</h5>
    </div>
    <div className="rightInfo">
      <Badge color="success">{bic}</Badge>
    </div>
  </div>
);

const renderCompanyId = company_id => (
  <div className="mt-20">
    <div className="leftInfo">
      <h5 className="bold-text">№ d'immatriculation</h5>
    </div>
    <div className="rightInfo">
      <Badge color="success">{company_id}</Badge>
    </div>
  </div>
);

const renderRole = role => (
  <div className="mt-20">
    <div className="leftInfo">
      <h5 className="bold-text">Rôle</h5>
    </div>
    <div className="rightInfo">
      <Badge color="success">{role}</Badge>
    </div>
  </div>
);

const renderNatureParts = nature_parts => (
  <div className="mt-20">
    <div className="leftInfo">
      <h5 className="bold-text">Nature des parts</h5>
    </div>
    <div className="rightInfo">
      <Badge color="success">{getNaturePartByValue(nature_parts)}</Badge>
    </div>
  </div>
);

const renderNbParts = nb_parts => (
  <div className="mt-20">
    <div className="leftInfo">
      <h5 className="bold-text">Nombre de parts</h5>
    </div>
    <div className="rightInfo">
      <Badge color="success">{nb_parts}</Badge>
    </div>
  </div>
);

const renderContract = data => (
  <div className="mt-20">
    <div className="leftInfo">
      <h5 className="bold-text">Nom du contrat</h5>
    </div>
    <div className="rightInfo">
      {
        data.contract ? (
          <Badge color="success">{data.contract_name}</Badge>
        ) : (
          <Badge color="warning">Non renseigné</Badge>
        )
      }
    </div>
    <div className="mt-20">
      <div className="leftInfo">
        <h5 className="bold-text">Numéro de contrat</h5>
      </div>
      <div className="rightInfo">
        {
          data.contract ? (
            <Badge color="success">{data.contract}</Badge>
          ) : (
            <Badge color="warning">Non renseigné</Badge>
          )
        }
      </div>
    </div>
  </div>
);

const renderDeposit = data => (
  <div className="mt-20">
    <div className="leftInfo">
      <h5 className="bold-text">№ de dépôt</h5>
    </div>
    <div className="rightInfo">
      {
        data.deposit_number ? (
          <Badge color="success">{data.deposit_number}</Badge>
        ) : (
          <Badge color="warning">Non renseigné</Badge>
        )
      }
    </div>
    <div className="mt-20">
      <div className="leftInfo">
        <h5 className="bold-text">Entité dépositaire</h5>
      </div>
      <div className="rightInfo">
        {
          data.deposit_entity ? (
            <Badge color="success">{data.deposit_entity}</Badge>
          ) : (
            <Badge color="warning">Non renseigné</Badge>
          )
        }
      </div>
    </div>
  </div>
);

const renderContacts = (data, contacts) => (
  <div className="mt-20">
    <div className="leftInfo">
      <h5 className="bold-text">Contacts utiles</h5>
    </div>
    <div className="rightInfo">
      <AssetModalContacts isMemorial contacts={contacts} data={data} />
    </div>
  </div>
);

const AssetModalContent = ({
  toggleAsset,
  data,
  contacts,
  accesses,
  setDocument,
}) => (
  <Row noGutters>
    <AssetModalLeft data={data} />
    <Col className="infoAssetContainer" md="8" style={{ padding: '1rem' }}>
      <AssetModalHeader data={data} toggleAsset={toggleAsset} />
      <div style={{ minHeight: 160 }}>
        {renderUsername(data, contacts, accesses)}
        {data.subcategory === 'crypto_wallet' && renderCryptoArea(data, contacts, accesses)}
        {(data.contract || data.contract_name) && renderContract(data)}
        {data.contract_type && renderContractType(data.contract_type)}
        {data.address && renderAddress(data)}
        {data.bic && renderBic(data.bic)}
        {data.company_id && renderCompanyId(data.company_id)}
        {data.role && renderRole(data.role)}
        {data.nature_parts && renderNatureParts(data.nature_parts)}
        {data.nb_parts && renderNbParts(data.nb_parts)}
        {(data.deposit_number || data.deposit_entity) && renderDeposit(data)}
        {data.contacts && data.contacts.length > 0 && (['industrial', 'copyright', 'madelin', 'collective_pension', 'employee_savings_plan', 'unlisted', 'family_company', 'sci'].includes(data.subcategory) || ['company'].includes(data.category)) && renderContacts(data, contacts)}
        <AssetModalContacts isViewOnly accesses={accesses} contacts={contacts} data={data} />
        {/* <AssetModalDecisions decisions={data.decisions} /> */}
        {data.isMemorial && renderMemorial(data, contacts)}
        {data.notes && renderNotes(data.notes)}
        {data.documents && data.documents.length > 0 && renderDocuments(data.documents, setDocument)}
        {data.images && data.images.length > 0 && renderImages(data.images, setDocument)}
      </div>
    </Col>
  </Row>
);

AssetModalContent.propTypes = {
  toggleAsset: PropTypes.func.isRequired,
  setDocument: PropTypes.func.isRequired,
  data: PropTypes.shape({}).isRequired,
  contacts: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
  accesses: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
};

export default AssetModalContent;
